const CookieKey = 'pcsadorg='

/**
 *
 * @constructor
 */
export  function KeepAd() {

    const lastAd = ReadLastAd()
    const inAd = PageParametre('p')

    if(inAd && inAd !== '' && lastAd !== inAd)
    {
        Cookies.set(CookieKey, inAd)
    }
}

/**
 *
 * @returns {string}
 * @constructor
 */
export function ReadLastAd() {

    if(Cookies.get(CookieKey))
    {
        return Cookies.get(CookieKey)
    }

    return ''
}
